module.exports = __webpack_public_path__ + "static/img/footer_img1.992093e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_img1.png
// module id = uo7H
// module chunks = 16